import { render, staticRenderFns } from "./Attribution.vue?vue&type=template&id=f75f2666&scoped=true"
import script from "./Attribution.vue?vue&type=script&lang=js"
export * from "./Attribution.vue?vue&type=script&lang=js"
import style0 from "./Attribution.vue?vue&type=style&index=0&id=f75f2666&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75f2666",
  null
  
)

export default component.exports